/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";

import { useForm, SubmitHandler, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";

import * as yup from "yup";
import { toast } from "react-toastify";
import jwt from "jsonwebtoken";
import apiUsuario from "../../../services/apiUsuario";

import { MenuLateralUsuario } from "../MenuLateralUsuario";
import {
  FormInputSelect,
  FormInputText,
} from "../../../components/form-inputs";

interface UsuarioProps {
  MATRICULA: string;
  CARGO: string;
  NOME: string;
  CPF: string;
  RG_FUNCIONAL: string;
  EMAIL: string;
  DATA_NASCIMENTO: string;
  TELEFONE: string;
  SETOR: string;
  ORGAO: string;
  BASE: string;
  SEXO: string;
}

const schemaCadastro = yup.object().shape({
  NOME: yup.string().required("Nome é obrigatório."),
  EMAIL: yup.string().required("Email é obrigatório."),
  CPF: yup
    .string()
    .max(11, "CPF é composto por 11 dígitos")
    .required("CPF é obrigatório e somente número."),
  CARGO: yup.string().required("Cargo é obrigatório."),
  BASE: yup.string().required("Escolha seu orgão."),
  SEXO: yup.string().required("Sexo é obrigatório."),
});

export const CadastroUsuario: React.FC = () => {
  const history = useHistory();
  const methods = useForm<UsuarioProps>({
    resolver: yupResolver(schemaCadastro),
  });
  const [isAlerta, setIsAlerta] = useState(true);
  const [isCivil, setIsCivil] = useState(false);
  const [isMandado, setIsMandado] = useState(false);
  const [isCarcerario, setIsCarcerario] = useState(false);
  const [isVeiculo, setIsVeiculo] = useState(false);
  const [isCriminal, setIsCriminal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState("");
  const [base, setBase] = useState("");
  const [tipoAcesso, setTipoAcesso] = useState("");

  useEffect(() => {
    const getToken = async () => {
      const tk = sessionStorage.getItem("@webSDS:token");
      if (tk) {
        setToken(tk);
        const decodedToken = jwt.decode(tk as string) as any;
        setBase(decodedToken.base);
        setTipoAcesso(decodedToken.id_acesso);
      }
    };
    getToken();
  }, []);

  const handleOnChangeAlerta = () => {
    setIsAlerta(!isAlerta);
  };

  const handleOnChangeAbis = () => {
    setIsCivil(!isCivil);
  };

  const handleOnChangeMandado = () => {
    setIsMandado(!isMandado);
  };
  const handleOnChangeCarcerario = () => {
    setIsCarcerario(!isCarcerario);
  };

  const handleOnChangeVeiculo = () => {
    setIsVeiculo(!isVeiculo);
  };

  const handleOnChangeCriminal = () => {
    setIsCriminal(!isCriminal);
  };

  const onSubmit: SubmitHandler<UsuarioProps> = async (data: UsuarioProps) => {
    setLoading(true);
    await schemaCadastro.validate(data, {
      abortEarly: false,
    });

    try {
      const arrSistemas = [];
      if (isAlerta) arrSistemas.push({ ID_SISTEMA: 1 });
      if (isCivil) arrSistemas.push({ ID_SISTEMA: 2 });
      if (isMandado) arrSistemas.push({ ID_SISTEMA: 3 });
      if (isCarcerario) arrSistemas.push({ ID_SISTEMA: 4 });
      if (isVeiculo) arrSistemas.push({ ID_SISTEMA: 8 });
      if (isCriminal) arrSistemas.push({ ID_SISTEMA: 9 });

      const response = await apiUsuario.post(
        "user",
        {
          MATRICULA: data.MATRICULA,
          CARGO: data.CARGO,
          NOME: data.NOME,
          CPF: data.CPF,
          RG_FUNCIONAL: data.RG_FUNCIONAL,
          EMAIL: data.EMAIL,
          DATA_NASCIMENTO: moment(data.DATA_NASCIMENTO).format("DD/MM/YYYY"),
          TELEFONE: data.TELEFONE,
          SETOR: data.SETOR,
          ORGAO: data.BASE,
          BASE: data.BASE,
          SEXO: data.SEXO,

          SISTEMAS: arrSistemas,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201) {
        toast.success(`${response.data}: ${data.EMAIL}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: false,
        });
        methods.reset();
      }
      if (response.status === 400) {
        toast.error(`${response.data.message}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      }
      if (response.status === 401) {
        toast.error(`${response.data.message}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      }
      if (response.status === 403) {
        toast.error(`${response.data.message}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      }
      if (response.status === 500 || response.status === 503) {
        toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      }
      if (response.status === 504) {
        toast.error(
          "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          }
        );
      }
      setTimeout(() => {
        setLoading(false);
      }, 200);
    } catch (err: any) {
      toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 4000,
      });
    }
  };

  return (
    <MUI.Stack flexDirection="row" width="100%" height="80vh">
      <MenuLateralUsuario />

      <MUI.Stack gap={2} p={2} flex={1}>
        {loading ? (
          <MUI.LinearProgress />
        ) : (
          <MUI.Stack gap={2} overflow="auto">
            <MUI.Stack>
              <MUI.Typography variant="h5" fontWeight="bold">
                CADASTRO DE USUÁRIO
              </MUI.Typography>
              <MUI.Typography variant="body2">
                Cadastre um usuário e defina suas permissões
              </MUI.Typography>
            </MUI.Stack>

            <FormProvider {...methods}>
              <MUI.Stack
                component="form"
                onSubmit={methods.handleSubmit(onSubmit)}
              >
                <MUI.Grid
                  alignItems="center"
                  width={["100%", "100%", "100%", "80%", "60%"]}
                  container
                  spacing={1}
                >
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <FormInputText
                      name="MATRICULA"
                      label="Matrícula"
                      maxSize={10}
                    />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <FormInputText name="NOME" label="Nome *" maxSize={120} />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <FormInputText name="EMAIL" label="Email *" maxSize={64} />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <FormInputText
                      name="RG_FUNCIONAL"
                      label="RG"
                      maxSize={15}
                    />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <FormInputText
                      name="CPF"
                      label="CPF *"
                      type="text"
                      maxSize={11}
                    />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <FormInputText name="CARGO" label="Cargo *" maxSize={50} />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <FormInputText
                      name="TELEFONE"
                      label="Telefone"
                      maxSize={16}
                    />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <FormInputText name="SETOR" label="Setor" maxSize={50} />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <FormInputText
                      name="DATA_NASCIMENTO"
                      label="Data de nascimento"
                      type="date"
                      maxSize={8}
                    />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <FormInputSelect
                      name="BASE"
                      label="Órgão *"
                      items={[
                        {
                          value: "ati",
                          label: "Agência Estadual de Tecnologia da Informação",
                        },
                        {
                          value: "dppe",
                          label: "Defensoria Pública do Estado de Pernambuco",
                        },
                        {
                          value: "detran_pe",
                          label:
                            "Departamento Estadual de Trânsito de Pernambuco",
                        },
                        {
                          value: "eb",
                          label: "Exército Brasileiro",
                        },
                        {
                          value: "fab",
                          label: "Força Aérea Brasileira",
                        },
                        {
                          value: "jfpe",
                          label: "Justiça Federal em Pernambuco",
                        },
                        {
                          value: "mb",
                          label: "Marinha do Brasil",
                        },
                        {
                          value: "mpf",
                          label: "Ministério Público Federal",
                        },
                        {
                          value: "mppe",
                          label: "Ministério Público de Pernambuco",
                        },
                        {
                          value: "pf",
                          label: "Polícia Federal",
                        },
                        {
                          value: "pge",
                          label: "Procuradoria Geral do Estado",
                        },
                        {
                          value: "dprf",
                          label: "Polícia Rodoviária Federal",
                        },
                        {
                          value: "tce",
                          label: "Tribunal de Contas de Pernambuco",
                        },
                        {
                          value: "tjpe",
                          label: "Tribunal de Justiça de Pernambuco",
                        },

                        {
                          value: "sefaz_pe",
                          label:
                            "Secretaria da Fazenda do Estado de Pernambuco",
                        },
                        {
                          value: "seplag",
                          label:
                            "Secretaria de Planejamento e Gestão de Pernambuco ",
                        },
                        {
                          value: "consulado",
                          label: "Consulado Americano",
                        },
                        {
                          value: "secop",
                          label: "SECOP - Caruaru",
                        },
                        {
                          value: "gm",
                          label: "Guarda Municipal",
                        },
                        {
                          value: "gcmrecife",
                          label: "GCM - Recife",
                        },
                      ].filter(
                        (o) =>
                          (o.value === base && tipoAcesso === "1") ||
                          tipoAcesso === "2"
                      )}
                    />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <FormInputSelect
                      name="SEXO"
                      label="Sexo *"
                      items={[
                        {
                          value: "M",
                          label: "Masculino",
                        },
                        {
                          value: "F",
                          label: "Feminino",
                        },
                      ]}
                    />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4} />
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <MUI.FormControlLabel
                      control={
                        <MUI.Checkbox
                          checked={isAlerta}
                          onChange={handleOnChangeAlerta}
                        />
                      }
                      label="Alerta celular / bike"
                    />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <MUI.FormControlLabel
                      control={
                        <MUI.Checkbox
                          checked={isCivil}
                          onChange={handleOnChangeAbis}
                        />
                      }
                      label="Consulta Civil"
                    />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <MUI.FormControlLabel
                      control={
                        <MUI.Checkbox
                          checked={isCriminal}
                          onChange={handleOnChangeCriminal}
                        />
                      }
                      label="Consulta Criminal"
                    />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <MUI.FormControlLabel
                      control={
                        <MUI.Checkbox
                          checked={isMandado}
                          onChange={handleOnChangeMandado}
                        />
                      }
                      label="Consulta mandado"
                    />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <MUI.FormControlLabel
                      control={
                        <MUI.Checkbox
                          checked={isCarcerario}
                          onChange={handleOnChangeCarcerario}
                        />
                      }
                      label="Consulta Carcerário"
                    />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <MUI.FormControlLabel
                      control={
                        <MUI.Checkbox
                          checked={isVeiculo}
                          onChange={handleOnChangeVeiculo}
                        />
                      }
                      label="Consulta Veículo"
                    />
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <MUI.Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      type="submit"
                      startIcon={<Icon.Save />}
                    >
                      <MUI.Typography
                        variant="button"
                        whiteSpace="nowrap"
                        textOverflow="ellipsis"
                        overflow="hidden"
                      >
                        Salvar
                      </MUI.Typography>
                    </MUI.Button>
                  </MUI.Grid>
                  <MUI.Grid item xs={12} md={4} sm={4}>
                    <MUI.Button
                      fullWidth
                      variant="outlined"
                      color="secondary"
                      type="submit"
                      startIcon={<Icon.KeyboardReturn />}
                      onClick={
                        () => history.push("/gerenciamentodeusuario/listar")
                        // eslint-disable-next-line react/jsx-curly-newline
                      }
                    >
                      <MUI.Typography
                        variant="button"
                        whiteSpace="nowrap"
                        textOverflow="ellipsis"
                        overflow="hidden"
                      >
                        Voltar
                      </MUI.Typography>
                    </MUI.Button>
                  </MUI.Grid>
                </MUI.Grid>
              </MUI.Stack>
            </FormProvider>
          </MUI.Stack>
        )}
      </MUI.Stack>
    </MUI.Stack>
  );
};
